import { cloneNested } from '@/helpers/helpers'
import ORDER_TYPES_DICTIONARY from '@/dictionaries/orderTypes'
import ORDER_EVENT_KINDS_DICTIONARY from '@/dictionaries/orderEventKinds'

const orderModel = {
  id: null,
  type: '',
  private: false,
  prioritySignals: false,
  absolutePunctuality: false,
  infectious: false,
  isPrivate: false,
  returnTransport: false,
  patientOnBoard: false,
  startAt: '',
  endAt: '',
  status: '',
  eventKind: '',
  amountGross: 0,
  paymentMethod: null,
  commissionedBy: '',
  agreedWith: '',
  orderActivities: [],
  doctorUser: null,
  plannedTeamDefinition: null,
  plannedTeamDefinitions: [],
  isFirstAvailablePlanning: false,
  plannedAssignmentOffsetMinutes: null,
  plannedDurationMinutes: null,
  team: {
    teamDefinition: {},
    vehicle: {},
    paramedicUser: null,
    driverUser: {},
  },
  customerAddress: {
    // id: null,
    // alias: null,
    // address: null,
    // city: null,
    // name: null,
    // searchable: false,
    // zip: null
  },
  pickupAddress: {
    // id: null,
    // alias: null,
    // address: null,
    // city: null,
    // name: null,
    // searchable: false,
    // zip: null
  },
  pickupDetails: null,
  deliveryAddress: {
    // id: null,
    // alias: null,
    // address: null,
    // city: null,
    // name: null,
    // searchable: false,
    // zip: null
  },
  patientInfo: [],
  comments: [],
  customFieldValues: {},
  deliveryDetails: null,
  version: null,
  updatedAt: '',
  createdAt: '',
}

const orderEdited = cloneNested(orderModel)
const defaultOrder = cloneNested(orderModel)

const statuses = [
  'draft',
  'received',
  'confirmed',
  'shipment_received',
  'shipment_delivered',
  'on_way_to_pickup_point',
  'at_pickup_point',
  'patient_pick_up',
  'on_way_to_delivery_point',
  'at_delivery_point',
  'waiting_for_return_pickup',
  'return_patient_pick_up',
  'on_way_to_return_delivery_point',
  'at_return_delivery_point',
  'patient_delivery',
  'patient_not_taken',
  'patient_left_at_destination',
  'completed',
  'done',
  'cancelled',
]

export default {
  orderEdited,
  defaultOrder,
  orders: [],
  totalOrdersCount: 1,
  orderStatuses: [],
  orderWorkflow: null,
  statisticsByStartAt: {},
  transportHistory: {
    loading: false,
    error: false,
    initialized: false,
    count: 0,
    displayCount: '0',
    items: [],
    truncated: false,
    modalVisible: false,
    requestToken: 0,
  },
  statuses,
  types: ORDER_TYPES_DICTIONARY,
  eventKinds: ORDER_EVENT_KINDS_DICTIONARY,
}
